import React, { useEffect, useState } from "react";
import "./CampaignList.css";
import axios from "axios";
import styled from "styled-components"
import CampaignPlaceholder from "../../../assets/icons/campaign-placeholder.avif";
import { useDispatch, useSelector } from "react-redux";
import { AltArrowRight, AltArrowUp} from "solar-icon-set/arrows"
import { SirenRounded} from "solar-icon-set/security"
import {CloseCircle } from "solar-icon-set"
import { Collapse, IconButton, Modal, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import TableAdCopis from "./TableAdCopis";
import { fetchCampaignDetails } from "../../../store/campaigns-slice";
import ErrorModal from "./ErrorModal";

const CampaignList = ({campaigns, status, duration, searchTerm}) => {
  const [filteredList, setFilteredList] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [rowExpanded, setRowExpanded] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false) ;
  const [currentCampaign, setCurrentCampaign] = useState("") ;

  const dispatch = useDispatch() ;

  // useEffect(() => {
  //   if (searchTerm === "") {
  //     setFilteredList(campaigns)
  //   }else {

    
  //   const tmp = campaigns?.filter(item =>    
  //     item.campaign_name.toLowerCase().includes(searchTerm.toLowerCase())
  //   ? true
  //   : false)

  //   setFilteredList(tmp) ;
  //   }
  // }, [searchTerm, status])

  useEffect(() => {
    if (status !== "ALL_STATUS") {
  
        let tmp = campaigns?.filter(item => item.status === status )
        if (searchTerm !== "") {
           tmp = tmp?.filter(item =>    
            item.campaign_name.toLowerCase().includes(searchTerm.toLowerCase())
          ? true
          : false)
        }
        setFilteredList(tmp) ;
      
    }else {
      if (searchTerm === "") {
        setFilteredList(campaigns)
      }else {
  
      
      const tmp = campaigns?.filter(item =>    
        item.campaign_name.toLowerCase().includes(searchTerm.toLowerCase())
      ? true
      : false)
  
      setFilteredList(tmp) ;
      }
    }


  }, [status, searchTerm])

  useEffect(() => {
    if (status === "ALL_STATUS" && searchTerm ==="") {
      setFilteredList(campaigns)
    }
  }, [searchTerm, status, campaigns])

  useEffect(() => {
  }, [filteredList, campaigns])

  useEffect(() => {
  }, [searchTerm])


  // useEffect(() => {
  //   async function getCampaignData() {
  //     const response = await axios.get(
  //       `https://x.zocket.com/customer/ads/api/v1/get_campaigns?business_id=${user?.app_business_id}`
  //     );

  //     const data = [];
  //     for (let key in response.data.data) {
  //       data.push({
  //         id: key,
  //         budget: response.data.data[key].budget,
  //         clicks: response.data.data[key].clicks,
  //         reach: response.data.data[key].results,
  //         likes: response.data.data[key].likes,
  //         whatsapp_enquiry: response.data.data[key].whatsapp_enquiry,
  //         createdAt: response.data.data[key].campaign_created_at,
  //         city: response.data.data[key].city,
  //         campaign_name: response.data.data[key].campaign_name,
  //         img:
  //           response.data.data[key].media &&
  //           JSON.parse(response.data.data[key].media)[0].url,
  //         status: response.data.data[key].status,
  //         onOf: response.data.data[key].onOf,
  //         startDate: response.data.data[key].startDate,
  //       });
  //     }
  //     // setCampaignData(data);
  //     console.log(data);
  //   }
  //   getCampaignData();
  // }, []);

  const getFormatedStatus = (status) => {
    if (status === "AWAITING_APPROVAL") return "Pending";
    else if (status === "COMPLETED_CAMPAIGNS") return "Completed";
    else if (status === "PAUSED_CAMPAIGNS") return "Paused";
    else if (status === "ONHOLD_CAMPAIGNS") return "Onhold";
    else if (status === "LIVE_CAMPAIGNS") return "Live now";
  }

  const getStatusColor = (status) => {
    if (status === "AWAITING_APPROVAL") return ["#9E9E9E", "#FAFAFA"];
    else if (status === "COMPLETED_CAMPAIGNS") return ["#1976D2", "#E3F2FD"];
    else if (status === "PAUSED_CAMPAIGNS") return ["#F44336","#FFEBEE"];
    else if (status === "ONHOLD_CAMPAIGNS") return ["#F4511E","#FFF3E0"];
    else if (status === "LIVE_CAMPAIGNS") return ["#7CB342", "#F1F8E9"] ;
  }

  const handle_expand_row = (i, campaignId) => {
    console.log("hello", i)
    setRowExpanded(rowExpanded === i ? null : i)
    dispatch(fetchCampaignDetails({
      campaignId: campaignId
    }))
  }

  const handleShowErrorModal = (e, data) => {
    e.stopPropagation();
    setShowErrorModal(true) ;

    setCurrentCampaign(data);
  }


  return (
    <div className="campaign-list">
      <Table class="table">
        <TableHead style={{background: "#fff",  border:"none", textTransform: "uppercase", letterSpacing: "1px"}} > 
        {/* <thead> */}
          <TableRow>
            {/* <th scope="col">
              <input type="checkbox" name="checkbox" />
            </th> */}
            <TableCell style={{textAlign: "left", color: "#00000080"}}   scope="col">Campaign</TableCell>
            <TableCell align="center" style={{color: "#00000080"}} scope="col">Budget</TableCell>
            {/* <TableCell scope="col">Location</TableCell> */}
            <TableCell align="center" style={{color: "#00000080"}} scope="col">Reach</TableCell>
            <TableCell align="center" style={{color: "#00000080"}} scope="col">Likes</TableCell>
            <TableCell align="center" style={{textAlign: "center", color: "#00000080"}} scope="col">Ad spend</TableCell>
            <TableCell align="center" style={{textAlign: "center", color: "#00000080"}} scope="col">Whatsapp enquiry</TableCell>
            <TableCell style={{color: "#00000080", textAlign: "center",}}  scope="col">Status</TableCell>
            <TableCell />
          </TableRow>
          </TableHead>
        {/* </thead> */}
        <TableBody>
          {filteredList && 
            filteredList.map((data, i) => {
              return (
                <>
                <TableRow onClick={() =>  handle_expand_row(i, data.id) } key={data.id} className="campaignList">
                  {/* <td>
                    <input type="checkbox" name="checkbox" />
                  </td> */}
                  <TableCell>
                    <div className="campaign-section">
                      <img
                        src={data?.product_media?.at(0)?.url  || CampaignPlaceholder}
                        alt={data.campaign_name}
                        className="cam-img"
                      />

                      <div className="cam-des">
                        <p className="cam-name">{data.campaign_type}</p>
                        <p className="cam-date">Created on {data.created_at}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="center" >{data.p_budget}</TableCell>
                  {/* <TableCell className="c-city">{data.city}</TableCell> */}
                  <TableCell align="center">{data.results}</TableCell>
                  <TableCell align="center">{data.likes}</TableCell>
                  <TableCell  align="center">{data?.spend}</TableCell>
                  <TableCell style={{textAlign: "center"}}>{data.chat}</TableCell>
                  <TableCell >
                    <div style={{display: "flex" , alignItems: "center", gap: "0.1rem", justifyContent: "center"}} >
                      <span style={{padding: "0.5rem 1.2rem", margin: "0", borderRadius: "1rem", backgroundColor: getStatusColor(data.status)[1], color: getStatusColor(data.status)[0]}}>
                        {getFormatedStatus(data?.status)}
                      </span>
                      {data.status === "ONHOLD_CAMPAIGNS" && <SirenRounded onClick={(e) => handleShowErrorModal(e, data)}  size={25} color="red" iconStyle="BoldDuotone" />}
                      
                    </div>
                  </TableCell>
                  <TableCell>
                    <IconButton type="button" >
                      {rowExpanded === i ? <AltArrowUp size={20}  /> : <AltArrowRight size={20}  />}
                    </IconButton>
                  </TableCell>
                </TableRow>
                <TableRow style={{border: "none"}} >
                  <TableCell style={{border: "none"}} colSpan={7}>
                    <Collapse in={rowExpanded === i} timeout="auto" unmountOnExit>
                      <TableAdCopis campaign={ filteredList[rowExpanded]}  />
                    </Collapse>
                  </TableCell>
                </TableRow>
                </>
              );
            })}
        </TableBody>
      </Table>
      <Modal open={showErrorModal} onClose={() => setShowErrorModal(false)} >
            <ErrorModal campaign={currentCampaign} setShowErrorModal={setShowErrorModal} />
      </Modal>
    </div>
  );
};

export default CampaignList;

// export const StatusChip = styled.div`
//   margin: auto;
//   font-size: 0.8rem;
//   width: 6rem;
//   text-align: center;
//   border-radius: 4rem;
//   padding: 0.1rem 0.3rem;
//   background-color: ${(props) => {
//     if (props.status === "LIVE_CAMPAIGNS") {
//       return "#f1f8e9";
//     } else if (props.status === "STOPPED_CAMPAIGNS") {
//       return "#ffecb3";
//     } else if (props.status === "COMPLETED_CAMPAIGNS") {
//       return "#e1f5fe";
//     } else if (props.status === "AWAITING_APPROVAL") {
//       return "#FFF8E0";
//     }
//   }};

//   color: ${(props) => {
//     if (props.status === "LIVE_CAMPAIGNS") {
//       return "#689f38";
//     } else if (props.status === "STOPPED_CAMPAIGNS") {
//       return "#ef6c00";
//     } else if (props.status === "COMPLETED_CAMPAIGNS") {
//       return "#0288d1";
//     } else if (props.status === "AWAITING_APPROVAL") {
//       return "#D1A307";
//     }
//   }};
// `;
